package com.karawek.core.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreShapes
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

enum class CoreNoticeTone {
    Info,
    Warning,
    Success,
}

@Composable
fun CoreNoticeCard(
    title: String,
    message: String,
    modifier: Modifier = Modifier,
    tone: CoreNoticeTone = CoreNoticeTone.Info,
) {
    val selectedSurface = CoreTheme.colors.primary.copy(alpha = CoreAlphas.SelectedSurface)
    val (bg, fg) = when (tone) {
        CoreNoticeTone.Info -> CoreTheme.colors.infoSurface to CoreTheme.colors.onBackground
        CoreNoticeTone.Warning -> CoreTheme.colors.warningSurface to CoreTheme.colors.onBackground
        CoreNoticeTone.Success -> CoreTheme.colors.errorSurface to CoreTheme.colors.onBackground
    }

    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(bg, CoreShapes.lg)
            .padding(CoreSpacing.lg),
    ) {
        Text(
            text = title,
            style = CoreTypography.caption,
            fontWeight = FontWeight.SemiBold,
            color = fg,
        )
        Spacer(modifier = Modifier.height(CoreSpacing.sm))
        Text(
            text = message,
            style = CoreTypography.bodySecondary,
            color = CoreTheme.colors.onBackground,
        )
    }
}
